import React from 'react';
import { Element } from 'react-scroll';
import Nav from '../../components/Nav';
import BackToTop from '../../components/BackToTop';
import Header from '../Header/';
import About from '../About';
import Stars from '../Stars';
import Awards from '../Awards';
import Footer from '../Footer/';
import Sponsors from '../Sponsors/';
import styles from './App.css';

const App = () => (
  <div className={styles.app}>
    <Nav />
    <BackToTop />
    <Header />
    <Element name="關於金羽">
      <About />
    </Element>
    <Element name="星光雲集">
      <Stars />
    </Element>
    <Awards />
    <Sponsors />
    <Footer />
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/sections/App/index.js